import { FC, useContext, useEffect, useState } from "react";
import { KYCTabStyle } from "../Styles/ProfilePagesStyles";
import { Chip } from "@material-ui/core";
import { PiSealCheckBold, PiSealWarningBold } from "react-icons/pi";
import AuthContext from "../../store/Auth/AuthContext";
import WalletContext from "../../store/Wallet/WalletContext";

const KYCFrame: FC<any> = () => {

    const classes = KYCTabStyle();

    const { getProfileData } = useContext<any>(AuthContext);
    const { hasKycWallet } = useContext<any>(WalletContext);

    const [label, setLabel]  = useState<string | null>();

    useEffect(() => {
        if (getProfileData && getProfileData.kycStatus) {
            switch(getProfileData.kycStatus) {
                case "inreview":
                    setLabel("Pending Review")
                    return
                case "incomplete":
                    setLabel("Pending Completion")
                    return
                case "waiting":
                    setLabel("Pending Review")
                    return
                case "blocked":
                    setLabel("Contact Support")
                    return
                case "rejected":
                    setLabel("KYC Temporarily Rejected")
                    return
                case "approved":
                    if (hasKycWallet) setLabel("Approved")
                    else setLabel("Unverified Wallet")
                    return
                default:
                    setLabel("Unverified")
            }
        } else {
            setLabel('Unverified');
        }
    }, [getProfileData, hasKycWallet])
    
    return (
        <Chip
            avatar={ getProfileData && getProfileData.kycStatus === 'approved' && hasKycWallet ? <PiSealCheckBold />
            : <PiSealWarningBold /> } 
            label={ label }
            className={`${classes.chip} ${getProfileData && getProfileData.kycStatus ? getProfileData.kycStatus === 'approved' ? hasKycWallet ? getProfileData.kycStatus : 'unverified' : getProfileData.kycStatus : 'unverified'}`}
        />
    )
}

export default KYCFrame;